(function (e, a) {
  for (var i in a) {
    e[i] = a[i];
  }
})(exports,
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // define getter function for harmony exports

  /******/

  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        enumerable: true,
        get: getter
      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // define __esModule on exports

  /******/


  __webpack_require__.r = function (exports) {
    /******/
    if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/
      Object.defineProperty(exports, Symbol.toStringTag, {
        value: 'Module'
      });
      /******/
    }
    /******/


    Object.defineProperty(exports, '__esModule', {
      value: true
    });
    /******/
  };
  /******/

  /******/
  // create a fake namespace object

  /******/
  // mode & 1: value is a module id, require it

  /******/
  // mode & 2: merge all properties of value into the ns

  /******/
  // mode & 4: return value when already ns object

  /******/
  // mode & 8|1: behave like require

  /******/


  __webpack_require__.t = function (value, mode) {
    /******/
    if (mode & 1) value = __webpack_require__(value);
    /******/

    if (mode & 8) return value;
    /******/

    if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
    /******/

    var ns = Object.create(null);
    /******/

    __webpack_require__.r(ns);
    /******/


    Object.defineProperty(ns, 'default', {
      enumerable: true,
      value: value
    });
    /******/

    if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    }
    /******/

    return ns;
    /******/
  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = "./src/index.js");
  /******/
}(
/************************************************************************/

/******/
{
  /***/
  "./src/basic.functions.js":
  /*!********************************!*\
    !*** ./src/basic.functions.js ***!
    \********************************/

  /*! exports provided: assign, keys, k, values, v, merge, m, rollup, flattenArrs, valuesWithKey, shallowClone, arrayClone, kv, pairs, kvr, objMap, objForEach, doAsync, isArray, isString, noop, sleep, wait, rand, unique, arrayOf, ellipsis, Emitter, trimStart, throttle, debounce */

  /***/
  function srcBasicFunctionsJs(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__);
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "assign", function () {
      return assign;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "keys", function () {
      return keys;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "k", function () {
      return k;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "values", function () {
      return values;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "v", function () {
      return v;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "merge", function () {
      return merge;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "m", function () {
      return m;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "rollup", function () {
      return rollup;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "flattenArrs", function () {
      return flattenArrs;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "valuesWithKey", function () {
      return valuesWithKey;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "shallowClone", function () {
      return shallowClone;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "arrayClone", function () {
      return arrayClone;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "kv", function () {
      return kv;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "pairs", function () {
      return pairs;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "kvr", function () {
      return kvr;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "objMap", function () {
      return objMap;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "objForEach", function () {
      return objForEach;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "doAsync", function () {
      return doAsync;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "isArray", function () {
      return isArray;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "isString", function () {
      return isString;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "noop", function () {
      return noop;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "sleep", function () {
      return sleep;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "wait", function () {
      return wait;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "rand", function () {
      return rand;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "unique", function () {
      return unique;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "arrayOf", function () {
      return arrayOf;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "ellipsis", function () {
      return ellipsis;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "Emitter", function () {
      return Emitter;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "trimStart", function () {
      return trimStart;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "throttle", function () {
      return throttle;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "debounce", function () {
      return debounce;
    });

    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    function _defineProperty(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }

      return obj;
    }

    var assign = Object.assign;

    var keys = function keys(obj) {
      return Object.keys(obj || {});
    };

    var k = keys;

    var values = function values(obj) {
      return keys(obj).map(function (k) {
        return obj[k];
      });
    };

    var v = values;

    var merge = function merge() {
      for (var _len = arguments.length, objs = Array(_len), _key = 0; _key < _len; _key++) {
        objs[_key] = arguments[_key];
      }

      return Object.assign.apply(Object, [{}].concat(objs));
    };

    var m = merge;

    var rollup = function rollup(arr) {
      var deriveValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
        return true;
      };
      return arr.reduce(function (obj, str) {
        return merge(obj, _defineProperty({}, str, deriveValue(str)));
      }, {});
    };

    var flattenArrs = function flattenArrs(arrs) {
      return arrs.reduce(function (flat, arr) {
        return flat.concat(arr);
      }, []);
    };

    var valuesWithKey = function valuesWithKey(obj) {
      return keys(obj).map(function (k) {
        return merge(obj[k], {
          _key: k
        });
      });
    };

    var shallowClone = merge;

    var arrayClone = function arrayClone(arr) {
      return arr.slice(0);
    };

    var kv = function kv(obj) {
      return keys(obj).map(function (k) {
        return {
          k: k,
          v: obj[k]
        };
      });
    };

    var pairs = kv;

    var kvr = function kvr(kv) {
      return kv.reduce(function (o, _ref) {
        var k = _ref.k,
            v = _ref.v;
        return merge(o, _defineProperty({}, k, v));
      }, {});
    };

    var objMap = function objMap(obj, fn) {
      return kv(obj).reduce(function (o, _ref2) {
        var k = _ref2.k,
            v = _ref2.v;
        return merge(o, _defineProperty({}, k, fn(v, k)));
      }, {});
    };

    var objForEach = objMap;

    var doAsync = function doAsync(fn) {
      var ms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return new Promise(function (resolve) {
        return setTimeout(function () {
          return resolve(fn());
        }, ms);
      });
    };

    var isArray = function isArray(thing) {
      return Array.isArray(thing);
    };

    var isString = function isString(thing) {
      return typeof thing === 'string';
    };

    var noop = function noop() {
      return undefined;
    };

    var sleep = function sleep(ms) {
      return new Promise(function (r) {
        return setTimeout(r, ms);
      });
    };

    var wait = sleep;

    var rand = function rand() {
      var from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
      return Math.floor(Math.random() * to) + from;
    };

    var unique = function unique() {
      for (var _len2 = arguments.length, arrs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        arrs[_key2] = arguments[_key2];
      }

      return Array.from(new Set(arrs.reduce(function (c, a) {
        return c.concat(a);
      })));
    };

    var arrayOf = function arrayOf() {
      var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return new Array(length).fill(true);
    };

    var ellipsis = function ellipsis() {
      var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var maxLength = arguments[1];
      return str.length > maxLength ? str.substring(0, maxLength).trim() + '...' : str;
    };

    var Emitter = function () {
      function Emitter() {
        _classCallCheck(this, Emitter);

        this.handlers = [];
      }

      _createClass(Emitter, [{
        key: 'subscribe',
        value: function subscribe(handler) {
          this.handlers.push(handler);
        }
      }, {
        key: 'unsubscribe',
        value: function unsubscribe(handler) {
          this.handlers = this.handlers.filter(function (h) {
            return h !== handler;
          });
        }
      }, {
        key: 'emit',
        value: function emit(result) {
          this.handlers.forEach(function (handler) {
            return handler(result);
          });
        }
      }]);

      return Emitter;
    }();

    var trimStart = function trimStart(str) {
      if (str.trimStart) return str.trimStart();
      if (str.trimLeft) return str.trimLeft();
      var trimmed = str.trim();
      var startIndex = str.indexOf(trimmed);
      return str.slice(startIndex, str.length);
    };

    var throttle = function throttle(func, limit) {
      var lastFunc = void 0;
      var lastRan = void 0;
      return function () {
        var context = this;
        var args = arguments;

        if (!lastRan) {
          func.apply(context, args);
          lastRan = Date.now();
        } else {
          clearTimeout(lastFunc);
          lastFunc = setTimeout(function () {
            if (Date.now() - lastRan >= limit) {
              func.apply(context, args);
              lastRan = Date.now();
            }
          }, limit - (Date.now() - lastRan));
        }
      };
    };

    var debounce = function debounce(func, delay) {
      var inDebounce = void 0;
      return function () {
        var context = this;
        var args = arguments;
        clearTimeout(inDebounce);
        inDebounce = setTimeout(function () {
          return func.apply(context, args);
        }, delay);
      };
    };
    /***/

  },

  /***/
  "./src/index.js":
  /*!**********************!*\
    !*** ./src/index.js ***!
    \**********************/

  /*! exports provided: assign, keys, k, values, v, merge, m, rollup, flattenArrs, valuesWithKey, shallowClone, arrayClone, kv, pairs, kvr, objMap, objForEach, doAsync, isArray, isString, noop, sleep, wait, rand, unique, arrayOf, ellipsis, Emitter, trimStart, throttle, debounce, encodeEmail, decodeEamil, flatMap, assert, howLongAgo, howLongFromNow, isToday, isThisYear, consoleOutUpdatedProps, consoleOutUpdatedState */

  /***/
  function srcIndexJs(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__);
    /* harmony import */


    var _basic_functions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
    /*! ./basic.functions */
    "./src/basic.functions.js");
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "assign", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["assign"];
    });
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "keys", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["keys"];
    });
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "k", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["k"];
    });
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "values", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["values"];
    });
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "v", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["v"];
    });
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "merge", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["merge"];
    });
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "m", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["m"];
    });
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "rollup", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["rollup"];
    });
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "flattenArrs", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["flattenArrs"];
    });
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "valuesWithKey", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["valuesWithKey"];
    });
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "shallowClone", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["shallowClone"];
    });
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "arrayClone", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["arrayClone"];
    });
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "kv", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["kv"];
    });
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "pairs", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["pairs"];
    });
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "kvr", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["kvr"];
    });
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "objMap", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["objMap"];
    });
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "objForEach", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["objForEach"];
    });
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "doAsync", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["doAsync"];
    });
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "isArray", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["isArray"];
    });
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "isString", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["isString"];
    });
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "noop", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["noop"];
    });
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "sleep", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["sleep"];
    });
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "wait", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["wait"];
    });
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "rand", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["rand"];
    });
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "unique", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["unique"];
    });
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "arrayOf", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["arrayOf"];
    });
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "ellipsis", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["ellipsis"];
    });
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "Emitter", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["Emitter"];
    });
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "trimStart", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["trimStart"];
    });
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "throttle", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["throttle"];
    });
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "debounce", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["debounce"];
    });
    /* harmony import */


    var _misc_functions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
    /*! ./misc.functions */
    "./src/misc.functions.js");
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "encodeEmail", function () {
      return _misc_functions__WEBPACK_IMPORTED_MODULE_1__["encodeEmail"];
    });
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "decodeEamil", function () {
      return _misc_functions__WEBPACK_IMPORTED_MODULE_1__["decodeEamil"];
    });
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "flatMap", function () {
      return _misc_functions__WEBPACK_IMPORTED_MODULE_1__["flatMap"];
    });
    /* harmony import */


    var _testing_functions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
    /*! ./testing.functions */
    "./src/testing.functions.js");
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "assert", function () {
      return _testing_functions__WEBPACK_IMPORTED_MODULE_2__["assert"];
    });
    /* harmony import */


    var _time_functions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
    /*! ./time.functions */
    "./src/time.functions.js");
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "howLongAgo", function () {
      return _time_functions__WEBPACK_IMPORTED_MODULE_3__["howLongAgo"];
    });
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "howLongFromNow", function () {
      return _time_functions__WEBPACK_IMPORTED_MODULE_3__["howLongFromNow"];
    });
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "isToday", function () {
      return _time_functions__WEBPACK_IMPORTED_MODULE_3__["isToday"];
    });
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "isThisYear", function () {
      return _time_functions__WEBPACK_IMPORTED_MODULE_3__["isThisYear"];
    });
    /* harmony import */


    var _react_functions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
    /*! ./react.functions */
    "./src/react.functions.js");
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "consoleOutUpdatedProps", function () {
      return _react_functions__WEBPACK_IMPORTED_MODULE_4__["consoleOutUpdatedProps"];
    });
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "consoleOutUpdatedState", function () {
      return _react_functions__WEBPACK_IMPORTED_MODULE_4__["consoleOutUpdatedState"];
    });
    /***/

  },

  /***/
  "./src/misc.functions.js":
  /*!*******************************!*\
    !*** ./src/misc.functions.js ***!
    \*******************************/

  /*! exports provided: keys, values, pairs, merge, encodeEmail, decodeEamil, flatMap, throttle, debounce */

  /***/
  function srcMiscFunctionsJs(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__);
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "keys", function () {
      return keys;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "values", function () {
      return values;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "pairs", function () {
      return pairs;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "merge", function () {
      return merge;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "encodeEmail", function () {
      return encodeEmail;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "decodeEamil", function () {
      return decodeEamil;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "flatMap", function () {
      return flatMap;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "throttle", function () {
      return throttle;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "debounce", function () {
      return debounce;
    });

    var keys = function keys(obj) {
      return Object.keys(obj || {});
    };

    var values = function values(obj) {
      return Object.values(obj || {});
    };

    var pairs = function pairs(obj) {
      return keys(obj).map(function (k) {
        return {
          k: k,
          v: obj[k]
        };
      });
    };

    var merge = function merge() {
      for (var _len = arguments.length, objs = Array(_len), _key = 0; _key < _len; _key++) {
        objs[_key] = arguments[_key];
      }

      return Object.assign.apply(Object, [{}].concat(objs));
    };

    var encodeEmail = function encodeEmail(email) {
      return email.replace(/\./g, ',');
    };

    var decodeEamil = function decodeEamil(email) {
      return email.replace(/,/g, '.');
    };

    var flatMap = function flatMap(arr) {
      return function (mapFunc) {
        return (arr || []).map(mapFunc).reduce(function (flat, item) {
          return flat.concat(Array.isArray(item) ? item : [item]);
        }, []);
      };
    };

    var throttle = function throttle(func, delay) {
      var timeout = void 0;
      return function () {
        if (!timeout) {
          func();
          timeout = setTimeout(function () {
            timeout = null;
          }, delay);
        }
      };
    };

    var debounce = function debounce(func, delay) {
      var timeout = void 0;
      return function () {
        if (timeout) {
          clearTimeout(timeout);
        }

        timeout = setTimeout(function () {
          func();
        }, delay);
      };
    };
    /***/

  },

  /***/
  "./src/react.functions.js":
  /*!********************************!*\
    !*** ./src/react.functions.js ***!
    \********************************/

  /*! exports provided: consoleOutUpdatedProps, consoleOutUpdatedState */

  /***/
  function srcReactFunctionsJs(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__);
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "consoleOutUpdatedProps", function () {
      return consoleOutUpdatedProps;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "consoleOutUpdatedState", function () {
      return consoleOutUpdatedState;
    });

    var consoleOutUpdatedProps = function consoleOutUpdatedProps(_this) {
      var v = Object.values(_this.props);
      var k = Object.keys(_this.props);
      var lv = Object.values(_this.__lastProps || {});
      var lk = Object.keys(_this.__lastProps || {}); // @todo: ignores props that disappeared

      var updatedProps = v.filter(function (i) {
        return !lv.includes(i);
      }).map(function (i) {
        return k[v.indexOf(i)];
      });
      if (updatedProps.length) console.log(_this.constructor.name + ' props updated', updatedProps);
      _this.__lastProps = _this.props;
    };

    var consoleOutUpdatedState = function consoleOutUpdatedState(_this) {
      var v = Object.values(_this.state);
      var k = Object.keys(_this.state);
      var lv = Object.values(_this.__lastState || {});
      var lk = Object.keys(_this.__lastState || {}); // @todo: ignores state that disappeared

      var updatedState = v.filter(function (i) {
        return !lv.includes(i);
      }).map(function (i) {
        return k[v.indexOf(i)];
      });
      if (updatedState.length) console.log(_this.constructor.name + ' state updated', updatedState);
      _this.__lastState = _this.state;
    };
    /***/

  },

  /***/
  "./src/testing.functions.js":
  /*!**********************************!*\
    !*** ./src/testing.functions.js ***!
    \**********************************/

  /*! exports provided: assert */

  /***/
  function srcTestingFunctionsJs(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__);
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "assert", function () {
      return assert;
    });

    var assert = function assert(assertions) {
      if (!expect) throw new Error('assert() can only be used in a testing environment');
      assertions.forEach(function (a) {
        return expect(a).toBeTruthy();
      });
    };
    /***/

  },

  /***/
  "./src/time.functions.js":
  /*!*******************************!*\
    !*** ./src/time.functions.js ***!
    \*******************************/

  /*! exports provided: howLongAgo, howLongFromNow, isToday, isThisYear */

  /***/
  function srcTimeFunctionsJs(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__);
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "howLongAgo", function () {
      return howLongAgo;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "howLongFromNow", function () {
      return howLongFromNow;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "isToday", function () {
      return isToday;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "isThisYear", function () {
      return isThisYear;
    });

    function howLongAgo(previous) {
      var current = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.now();
      var msPerSecond = 1000;
      var msPerMinute = 60 * msPerSecond;
      var msPerHour = msPerMinute * 60;
      var msPerDay = msPerHour * 24;
      var msPerMonth = msPerDay * 30;
      var msPerYear = msPerDay * 365;
      var elapsed = current - previous;

      if (elapsed < msPerSecond * 10) {
        return 'just now';
      }

      if (elapsed < msPerMinute) {
        var seconds = Math.round(elapsed / msPerSecond);
        return seconds + ' second' + (seconds > 1 ? 's' : '') + ' ago';
      } else if (elapsed < msPerHour) {
        var minutes = Math.round(elapsed / msPerMinute);
        return minutes + ' minute' + (minutes > 1 ? 's' : '') + ' ago';
      } else if (elapsed < msPerDay) {
        var hours = Math.round(elapsed / msPerHour);
        return hours + ' hour' + (hours > 1 ? 's' : '') + ' ago';
      } else if (elapsed < msPerMonth) {
        var days = Math.round(elapsed / msPerDay);
        return days + ' day' + (days > 1 ? 's' : '') + ' ago';
      } else if (elapsed < msPerYear) {
        var months = Math.round(elapsed / msPerMonth);
        return months + ' month' + (months > 1 ? 's' : '') + ' ago';
      } else {
        var years = Math.round(elapsed / msPerYear);
        return years + ' year' + (years > 1 ? 's' : '') + ' ago';
      }
    }

    function howLongFromNow(then, now) {
      var msPerSecond = 1000;
      var msPerMinute = 60 * msPerSecond;
      var msPerHour = msPerMinute * 60;
      var msPerDay = msPerHour * 24;
      var msPerMonth = msPerDay * 30;
      var msPerYear = msPerDay * 365;
      var remaining = then - now;
      var eventDate = new Date(then);

      if (remaining < msPerSecond * 10) {
        return 'In a moment';
      }

      if (remaining < msPerMinute) {
        var seconds = Math.floor(remaining / msPerSecond);
        return 'In ' + seconds + ' seconds';
      } else if (remaining < msPerHour) {
        var minutes = Math.floor(remaining / msPerMinute);

        var _seconds = Math.floor(remaining / msPerSecond) % 60;

        return 'In ' + minutes + ' minutes and ' + _seconds + ' seconds';
      } else if (remaining < msPerDay) {
        var hours = Math.floor(remaining / msPerHour);
        return 'In ' + hours + ' hours at ' + eventDate.toLocaleTimeString('en-US', {
          hour: 'numeric',
          minute: 'numeric'
        });
      } else if (remaining < msPerMonth) {
        var days = Math.floor(remaining / msPerDay);

        if (days > 7) {
          return 'In ' + days + ' days:\n      ' + eventDate.toLocaleDateString('en-US', {
            weekday: 'short',
            month: 'short',
            day: 'numeric'
          }) + ' \n      at ' + eventDate.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: 'numeric'
          });
        } else if (days > 1) {
          return 'On ' + eventDate.toLocaleDateString('en-US', {
            weekday: 'long'
          }) + ',\n      ' + eventDate.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric'
          }) + ' \n      at ' + eventDate.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: 'numeric'
          });
        } else {
          return 'Tomorrow at ' + eventDate.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: 'numeric'
          });
        }
      } else if (remaining < msPerYear) {
        var months = Math.floor(remaining / msPerMonth);

        if (months > 1) {
          return 'In ' + months + ' months: \n        ' + eventDate.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric'
          }) + ' \n        at ' + eventDate.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: 'numeric'
          });
        } else {
          return 'Next month: \n      ' + eventDate.toLocaleDateString('en-US', {
            weekday: 'short',
            month: 'short',
            day: 'numeric'
          }) + ' \n      at ' + eventDate.toLocaleTimeString({
            hour: 'numeric',
            minute: 'numeric'
          });
        }
      } else {
        var years = Math.floor(remaining / msPerYear);
        return 'In ' + years + ' years: \n     ' + eventDate.toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric'
        });
      }
    }

    var isToday = function isToday(date, today) {
      return today.getFullYear() === date.getFullYear() && today.getMonth() === date.getMonth() && today.getDate() === date.getDate();
    };

    var isThisYear = function isThisYear(date, today) {
      return today.getFullYear() === date.getFullYear();
    };
    /***/

  }
  /******/

}));